import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, retry, timer } from 'rxjs';

export const MAX_RETRIES = 3;
export const BASE_DELAY_MS = 1000;

export function isRetryable(error: HttpErrorResponse): boolean {
  return error.status === 0 || error.status >= 500;
}

export const retryLoggingInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    retry({
      count: MAX_RETRIES,
      delay: (error: HttpErrorResponse, retryCount: number) => {
        if (!isRetryable(error)) throw error;
        const delayMs = Math.pow(2, retryCount - 1) * BASE_DELAY_MS;
        console.warn(
          `[HTTP] Retry ${retryCount}/${MAX_RETRIES} in ${delayMs}ms — ${req.url}`,
          error.message
        );
        return timer(delayMs);
      },
    }),
    catchError((error: HttpErrorResponse) => {
      console.error(`[HTTP] Request failed: ${req.url}`, error);
      throw error;
    })
  );
